{
  "title": "Greater Restoration",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level abjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (diamond dust worth at least 100 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You imbue a creature you touch with positive energy to undo a debilitating effect. You can reduce the target’s exhaustion level by one, or end one of the following effects on the target:",
    "One effect that charmed or petrified the target",
    "One curse, including the target’s attunement to a cursed magic item",
    "Any reduction to one of the target’s ability scores",
    "One effect reducing the target’s hit point maximum"
  ],
  "spellLists": ["artificer", "bard", "cleric", "druid", "ranger"]
}
